import React, { useContext, useEffect, useRef, useState } from 'react';
import { MLSMapContext } from '../../context/MLSMapContext';
import useOutsideClick from '../../hooks/useOutsideClick';
import mls_listing_statuses from '../../constants/mls_listing_statuses.json';

export default function MLSStatusDropdown() {
  const dropdownRef = useRef();

  const {
    statusFilters,
    setStatusFilters,
    statusDropdownVisible,
    setStatusDropdownVisible,
  } = useContext(MLSMapContext);

  const [localStatusFilters, setLocalStatusFilters] = useState(statusFilters);

  useEffect(() => {
    setLocalStatusFilters(statusFilters);
  }, [statusFilters]);

  useOutsideClick(dropdownRef, statusDropdownVisible, () => {
    setLocalStatusFilters(statusFilters);
    setStatusDropdownVisible(false);
  });
  return (
    <div ref={dropdownRef} className="dropdown-sorting-container">
      <h2 className="dropdown-title">Listing Status</h2>
      <button
        aria-label="Close Status Dropdown"
        name="Close Status Dropdown"
        type="button"
        className="mobile-dropdown-cancel btn btn--small"
        onClick={() => setStatusDropdownVisible(false)}
      >
        Close
      </button>
      <section className="dropdown-sorting-inputs">
        {mls_listing_statuses.map((status, ind) => {
          const isChecked = localStatusFilters.some(
            localStatus => localStatus.label === status.label
          );

          return (
            <label key={ind} htmlFor={`filters-status-${status.value}`}>
              <input
                aria-label={`${status.label}`}
                id={`filters-status-${status.value}`}
                type="checkbox"
                checked={isChecked}
                onChange={() => {
                  if (isChecked) {
                    // Remove
                    const localStatusFilterCopys = [...localStatusFilters];
                    setLocalStatusFilters(
                      localStatusFilterCopys.filter(
                        localStatus => localStatus.label !== status.label
                      )
                    );
                  } else {
                    // Add
                    setLocalStatusFilters([...localStatusFilters, status]);
                  }
                }}
              />
              <p>{status.label}</p>
            </label>
          );
        })}
      </section>
      <section className="dropdown-actions mobile-center">
        <button
          aria-label="Apply Status Filters"
          name="Apply Status Filters"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            setStatusFilters(localStatusFilters);
            setStatusDropdownVisible(false);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Status Filters"
          name="Clear Status Filters"
          type="button"
          className="btn btn--light"
          onClick={() => {
            setLocalStatusFilters([]);
            setStatusFilters([]);
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
